import React from 'react';
import Coupon from 'gatsby-matrix-theme/src/components/atoms/coupon';
import { getExtraField } from 'gatsby-core-theme/src/helpers/getters';

export default (props) => {
  const couponCode = getExtraField(props?.item?.extra_fields, 'coupon_code');
  return (
    <Coupon
      code={couponCode} 
      type="toplist"
      status={props?.item?.status}
      showprefix={false}
      templateOne={false}
      translationKey="code_toplist"
    />
  );
};
